import type { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "@/components/ui/data-table";
import { DeleteLibraryDialog } from "./DeleteLibraryDialog";
import { EditLibraryDialog } from "./EditLibraryDialog";
import { LibraryPermissionsDialog } from "./LibraryPermissionsDialog";
import type { DepartmentOption } from "./DocumentsFilters";
import type { DocumentLibrary } from "@/types/document";
import { formatOptionalArabicDate } from "@/lib/formatters";

interface DocumentLibrariesTableProps {
  libraries: DocumentLibrary[];
  departmentLookup: Record<string, string>;
  departments: DepartmentOption[];
}

export function DocumentLibrariesTable({
  libraries,
  departmentLookup,
  departments,
}: DocumentLibrariesTableProps) {
  const columns: ColumnDef<DocumentLibrary>[] = [
    { accessorKey: "title", header: "الاسم" },
    {
      accessorKey: "departmentId",
      header: "الدائرة",
      cell: ({ row }) => {
        const id = row.original.departmentId;
        return id ? (departmentLookup[id] ?? id) : "—";
      },
    },
    {
      accessorKey: "createdAt",
      header: "تاريخ الإنشاء",
      cell: ({ row }) => formatOptionalArabicDate(row.original.createdAt),
    },
    {
      id: "actions",
      header: "الإجراءات",
      cell: ({ row }) => (
        <div className="flex items-center justify-center gap-3">
          <EditLibraryDialog library={row.original} departments={departments} />
          <LibraryPermissionsDialog library={row.original} />
          <DeleteLibraryDialog library={row.original} />
        </div>
      ),
    },
  ];

  return <DataTable columns={columns} data={libraries} />;
}
